import type { FeatureCode } from "@/features/system-admin/constants/features";

export const FEATURE_LABEL_KEYS: Record<FeatureCode, string> = {
  knowledge_base: "labels.knowledge_base",
  workflows: "labels.workflows",
  agents: "labels.agents",
  kg: "labels.kg",
  mcp_workflow_authoring: "labels.mcp_workflow_authoring",
  mcp_raw_sql_execute: "labels.mcp_raw_sql_execute",
  workflow_http_nodes: "labels.workflow_http_nodes",
};
